import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select } from "antd";
import { strings } from "../../../helpers";

export default class AnalyticsView extends Component {
  render() {
    const {
      newsTagsList,
      allRecords,
      pageNo,
      onPageChange,
      handleTableChange
    } = this.props;

    const columns = [
      {
        title: "Name",
        key: "tag_name",
        align: "left",
        render: record => <div>{record.tag_name}</div>
      },
      {
        title: "No. of news published",
        key: "published_news_count",
        align: "left",
        sorter: true,
        render: record => <div>{record.published_news_count}</div>
      },
      {
        title: "Shared clicks",
        key: "shared_news_count",
        align: "left",
        sorter: true,
        render: record => <div>{record.shared_news_count}</div>
      },
      {
        title: "Shared views",
        key: "viewed_news_count",
        align: "left",
        sorter: true,
        render: record => <div>{record.viewed_news_count}</div>
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={24} className="heading-domain">
              Analytics
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              // onRowClick={record => navigateToDoctorDetails(record.id)}
              columns={columns}
              dataSource={newsTagsList}
              pagination={false}
              rowKey="id"
              onChange={handleTableChange}
            />
          </div>
          <div className="pagination-wrapper">
            {allRecords > 10 && (
              <div className="total-results-wrap">
                <span className="result-count">{allRecords}</span>
                {allRecords > 1 ? strings.results : strings.result}
              </div>
            )}
            {allRecords > 10 && (
              <Pagination
                total={allRecords}
                current={pageNo}
                onChange={onPageChange}
                pageSize={10}
                defaultCurrent={pageNo}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
